module.exports = __webpack_public_path__ + "frontend/images/miles/business-card-hand-x2-0bc953ea409fbe9540969fe9537d19ca.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/miles/business-card-hand-x2.png
// module id = 327
// module chunks = 2